import React, { FC } from 'react'

import { Button, Field, RiskLevelSlider, Select } from 'mf-ui-components'

import { ContributionField } from '../../../common/ContributionField'
import {
  ContributionFieldWrapper,
  ContributionFields,
  RegularScreenTimeSelector,
  RiskLevelContainer,
  SmallScreenTimeSelector,
} from './ExpectedPerformance.styles'
import rawlang, * as l10n from '../../../../utils/l10n'
import { TimeFrame } from './TimeFrame'
import { RISK_LEVELS, TIME_HORIZON_OPTIONS } from './libs'
import type { RiskLevel } from '../../../../types/ModelPortfolio'

const lang = rawlang as 'en' | 'it'

type Props = {
  errors: { initialContribution?: string; monthlyContribution?: string }
  isBelowTablet: boolean
  submitForm: () => void
  validateForm: () => void
  initialContribution: number
  setInitialContribution: (x: number) => void
  monthlyContribution: number
  setMonthlyContribution: (x: number) => void
  setTimeHorizon: (x: number) => void
  timeHorizon: number
  sliderRiskLevel: RiskLevel
  setSliderRiskLevel: (x: RiskLevel) => void
  setPortfolioRiskLevel: (x: RiskLevel) => void
}

export const Form: FC<Props> = ({
  errors,
  isBelowTablet,
  submitForm,
  validateForm,
  initialContribution,
  setInitialContribution,
  monthlyContribution,
  setMonthlyContribution,
  setTimeHorizon,
  timeHorizon,
  sliderRiskLevel,
  setSliderRiskLevel,
  setPortfolioRiskLevel,
}) => {
  const onContributionKeyDown = ({ key }: KeyboardEvent) => {
    if (key === 'Enter') submitForm()
  }

  return (
    <>
      <ContributionFields>
        <ContributionFieldWrapper>
          <ContributionField
            label={l10n.expected_performance.initial_contribution[lang]}
            error={errors.initialContribution}
            locale={process.env.GATSBY_COUNTRY}
            decimalScale={0}
            value={initialContribution ? initialContribution : ''}
            onBlur={isBelowTablet ? submitForm : validateForm}
            onKeyDown={onContributionKeyDown}
            onChange={({ value }: { value: string }) =>
              setInitialContribution(value !== '' ? Number(value) : 0)
            }
          />
        </ContributionFieldWrapper>
        <ContributionFieldWrapper>
          <ContributionField
            label={l10n.expected_performance.monthly_contribution[lang]}
            error={errors.monthlyContribution}
            locale={process.env.GATSBY_COUNTRY}
            decimalScale={0}
            value={monthlyContribution ? monthlyContribution : ''}
            onBlur={isBelowTablet ? submitForm : validateForm}
            onKeyDown={onContributionKeyDown}
            onChange={({ value }: { value: string }) =>
              setMonthlyContribution(value !== '' ? Number(value) : 0)
            }
          />
        </ContributionFieldWrapper>
      </ContributionFields>
      <Field label={l10n.expected_performance.time_horizon[lang]}>
        <>
          <SmallScreenTimeSelector>
            <TimeFrame
              options={TIME_HORIZON_OPTIONS}
              onChange={(x: number) => setTimeHorizon(x)}
              value={timeHorizon}
            />
          </SmallScreenTimeSelector>
          <RegularScreenTimeSelector>
            <Select
              options={TIME_HORIZON_OPTIONS}
              onChange={x => setTimeHorizon(Number(x.target.value))}
              value={timeHorizon}
            />
          </RegularScreenTimeSelector>
        </>
      </Field>
      <RiskLevelContainer>
        <RiskLevelSlider
          label={l10n.expected_performance.risk_level[lang]}
          min={RISK_LEVELS[0]}
          max={RISK_LEVELS[RISK_LEVELS.length - 1]}
          value={sliderRiskLevel}
          onChange={setSliderRiskLevel}
          onAfterChange={setPortfolioRiskLevel}
        />
      </RiskLevelContainer>

      {!isBelowTablet && (
        <Button size="normal" fullWidth onClick={submitForm}>
          {l10n.expected_performance.calculate[lang]}
        </Button>
      )}
    </>
  )
}
